import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { message } from 'antd';
import moment from 'moment';
import FeedbackDrawer from '../Drawer/Drawer';
import FeedbackButton from '../Feedback-button/FeedbackButton';
import {
  useAddFeedbackMutation,
  useGetFeedbackDataQuery,
  useUpdateFeedbackMutation,
} from '../store/feedbackSlice';
import {
  feedbackState,
  setFeedbackDrawerOpen,
  setRating,
  setTextareaValue,
} from '../store/stateSlice';
import { injectReducer } from '../../../../app/index';
import reducer from '../store';
import { authState } from '../../../../app/auth/authSlice';

injectReducer('feedback', reducer);

function Feedback() {
  const { rating, textareaValue, idleTime, drawerOpen } =
    useSelector(feedbackState);
  const [feedbackId, setFeedbackId] = useState<number | undefined>();
  const [addFeedback] = useAddFeedbackMutation();
  const dispatch = useDispatch();
  const [updateFeedback, { isLoading: updateLoading }] =
    useUpdateFeedbackMutation();
  const { profile } = useSelector(authState);

  const { data: feedback } = useGetFeedbackDataQuery(undefined, {
    skip: !idleTime,
  });

  const feedbackData = profile?.application_settings?.find(
    (item: any) => item.key_name === 'feedback'
  );

  const clearFeedbackState = () => {
    // set initial valut to the redux state after successfully submitting feedback.
    dispatch(setRating(0));
    dispatch(setTextareaValue(''));
  };

  const handleClick = useCallback(async () => {
    try {
      const data = {
        rating: 0,
        text: '',
        is_ignored: false,
        is_submitted: false,
      };
      const response = await addFeedback(data).unwrap();
      setFeedbackId(response?.id);
      dispatch(setFeedbackDrawerOpen(true));
    } catch (err) {
      console.log(err);
    }
  }, [addFeedback, dispatch]);

  const onClose = () => {
    dispatch(setFeedbackDrawerOpen(false));
    clearFeedbackState();
  };

  const onSkip = async () => {
    dispatch(setFeedbackDrawerOpen(false));
    clearFeedbackState();
  };

  const onSubmit = async () => {
    try {
      const id = feedback?.results[0]?.id || feedbackId;

      const data = {
        rating,
        text: textareaValue,
        is_ignored: false,
        is_submitted: true,
      };

      if (data?.rating > 0) {
        await updateFeedback({ data, id }).unwrap();
        message.success('Your feedback submitted successfully');
        dispatch(setFeedbackDrawerOpen(false));
        // set initial valut to the redux state after successfully submitting feedback.
        clearFeedbackState();
      } else {
        message.error('You must give a rating before submit');
      }
    } catch (error) {
      message.error('Something went wrong');
    }
  };

  useEffect(() => {
    if (feedbackData?.bool_value === true) {
      if (idleTime) {
        const feedbackDate = moment(feedback?.results[0]?.created_at);

        const dayDifference = moment().diff(feedbackDate, 'days');

        if (!feedback?.results[0]?.is_submitted && dayDifference >= 7) {
          handleClick();
        }
      }
    }
  }, [idleTime, feedbackData?.bool_value, feedback?.results, handleClick]);

  return (
    <div>
      <FeedbackButton handleClick={handleClick} />

      <FeedbackDrawer
        open={drawerOpen}
        onClose={onClose}
        onSkip={onSkip}
        onSubmit={onSubmit}
        updateLoading={updateLoading}
      />
    </div>
  );
}

export default Feedback;
